import React, { Component } from 'react'
import { Button, Row, Form, Input } from 'antd'
import {Link} from 'dva/router'
import config from '../../utils/config'

const FormItem = Form.Item

class Login extends Component {

    handleSubmit(e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }
            this.props.onOk(values)
        })
    }

    render() {
        const {getFieldDecorator} = this.props.form;

        return (
            <div className={"login-box-body portlet-body"}>
                <div className={"login-logo"}>
                    <img src={config.logoSrc} alt={config.logoText} />
                </div>

                <p className={'text-center paddingBottom20'}>Ingrese su usuario y contraseña</p>

                <Form onSubmit={this.handleSubmit.bind(this)}>
                    <FormItem hasFeedback>
                        {getFieldDecorator('username', {
                            rules: [{
                                required: true,
                                message: 'Por favor, ingrese el nombre de usuario'
                            }]
                        })(<Input size='large' onPressEnter={this.handleSubmit.bind(this)} placeholder='Usuario' />)}
                    </FormItem>

                    <FormItem hasFeedback>
                        {getFieldDecorator('password', {
                            rules: [{
                                required: true,
                                message: 'Por favor, ingrese la contraseña'
                            }]
                        })(<Input size='large' type='password' onPressEnter={this.handleSubmit.bind(this)} placeholder='Contraseña' />)}
                    </FormItem>

                    <Row className={'text-center'}>
                        <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.buttonLoading} className={'btn btn-primary btn-flat'}>
                            Iniciar sesión
                        </Button>
                    </Row>

                    <p className={'text-center paddingTop20'}><Link onClick={this.props.changeRecoveryPassword}>¿Olvidaste tu contraseña?</Link></p>
                </Form>
            </div>
        );
    }
};

export default Form.create()(Login)


// WEBPACK FOOTER //
// ./src/components/authentication/login.js